import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useUserRole } from '@/hooks/useUserRole';
import Header from '@/components/bionexus/Header';
import Footer from '@/components/Footer';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
}

const ProtectedRoute = ({ children, requireAdmin = false }: ProtectedRouteProps) => {
  const { user, loading: authLoading } = useAuth();
  const { isAdmin, isLoading: roleLoading } = useUserRole();

  // Show loading state
  if (authLoading || (user && roleLoading)) {
    return (
      <div className="min-h-screen bg-background flex flex-col">
        <Header />
        <main className="flex-1 flex items-center justify-center pt-20">
          <div className="text-center">
            <div className="animate-pulse font-mono text-xs uppercase tracking-[0.12em] text-muted-foreground">
              验证身份中...
            </div>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  // Not logged in - redirect to login
  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  // Logged in but not admin (when admin is required)
  if (requireAdmin && !isAdmin) {
    return (
      <div className="min-h-screen bg-background flex flex-col">
        <Header />
        <main className="flex-1 flex items-center justify-center pt-20">
          <div className="text-center px-6">
            <h1 className="font-display font-medium text-4xl text-destructive mb-4">
              访问被拒绝
            </h1>
            <p className="font-mono text-xs uppercase tracking-[0.12em] text-muted-foreground mb-2">
              Access Denied
            </p>
            <p className="text-muted-foreground mb-8">
              您没有访问此页面的权限。请联系管理员。
            </p>
            <a 
              href="/"
              className="inline-flex items-center gap-2 font-mono text-sm text-primary hover:underline"
            >
              ← 返回首页
            </a>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;
